import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap";
import { Fee, FeeType } from '../../../../../../projects/accounting/src/public_api';

@Component({
  selector: 'fee-definition-editor',
  templateUrl: './definition-editor.component.html',
  styleUrls: ['./definition-editor.component.scss']
})
export class DefinitionEditorComponent implements OnInit {

  @Input() data: Fee;
  @Output() commit = new EventEmitter<Fee>();

  message = '';

  types = [
    { value: FeeType.income, name: 'Phí doanh thu' },
    { value: FeeType.periodic, name: 'Phí Định kỳ' },
    { value: FeeType.oneTime, name: 'Phí Một lần' },
    { value: FeeType.unpredictable, name: 'Phí phát sinh' }
  ];

  constructor(
    public modal: BsModalRef
  ) {
  }

  creating: boolean = false;
  type:FeeType = FeeType.oneTime;

  ngOnInit() {

    if (this.data == null) {
      this.data = {
        name: '',
        description: '',
        type: FeeType.oneTime,
        active: true,
        data: ["Fee"]
      }

      this.creating = true;
    }
    else {

      let buffer: Fee = {
        id: this.data.id,
        name: this.data.name,
        description: this.data.description,
        type: this.data.type,
        active: this.data.active,
        data: []
      };

      if (typeof this.data.data != "undefined") this.data.data.forEach(i => buffer.data.push(i));

      if (buffer.type == FeeType.income) buffer.data[0] = (parseFloat(buffer.data[0]) * 100).toString();

      this.data = buffer;
    }
  }

  update() {

    switch (this.type) {
      case FeeType.income: this.data.data = ["0"]; break;
      case FeeType.oneTime: this.data.data = ["Fee"]; break;
      case FeeType.periodic: this.data.data = ["1", "Month", "0", "Fixed"]; break;
      default: this.data.data = []; break;
    }

    this.data.type = this.type;
  }

  emit() {

    if (this.data.name.trim() == '') {
      this.message = "Tên phí không được để trống";
      return;
    }

    if (this.data.description.trim() == '') {
      this.message = "Mô tả phí không được để trống";
      return;
    }

    if (this.data.type == FeeType.income) {

      let n = parseFloat(this.data.data[0]);

      if (isNaN(n)) {
        this.message = "Tỷ lệ % không hợp lệ";
        return;
      }

      if (n <= 0) {
        this.message = "Tỷ lệ % không được nhỏ hơn hoặc bằng 0";
        return;
      }

      this.data.data[0] = (n / 100).toString();
    }

    if (this.data.type == FeeType.periodic) {

      let n = parseInt(this.data.data[0]);

      if (isNaN(n)) {
        this.message = "Thời gian lặp lại không hợp lệ";
        return;
      }

      if (n <= 0) {
        this.message = "Thời gian lặp lại không được nhỏ hơn hoặc bằng 0";
        return;
      }

      n = parseFloat(this.data.data[2]);

      if (isNaN(n)) {
        this.message = "Số tiền không hợp lệ";
        return;
      }

      if (n <= 0) {
        this.message = "Số tiền không được nhỏ hơn hoặc bằng 0";
        return;
      }

      this.data.data[0] = this.data.data[0].toString();
      this.data.data[2] = this.data.data[2].toString();
    }

    this.commit.emit(this.data);
    this.modal.hide();
  }
}
